const ArrowBackIosNew = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_1683_11414"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect
        y="18"
        width="18"
        height="18"
        transform="rotate(-90 0 18)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_1683_11414)">
      <path
        d="M16.2404 6.00187L9.00008 13.2422L1.75977 6.00187L2.8242 4.93744L9.00008 11.1135L15.176 4.93744L16.2404 6.00187Z"
        fill="#535862"
      />
    </g>
  </svg>
);

export default ArrowBackIosNew;
